import { render } from "./SnehaSparshamApplicationStatusReport.vue?vue&type=template&id=407e08fb&scoped=true"
import script from "./SnehaSparshamApplicationStatusReport.vue?vue&type=script&lang=js"
export * from "./SnehaSparshamApplicationStatusReport.vue?vue&type=script&lang=js"

import "./SnehaSparshamApplicationStatusReport.vue?vue&type=style&index=0&id=407e08fb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-407e08fb"]])

export default __exports__